import { Component, Input } from '@angular/core';

@Component({
  selector: 'mytc-error-messages-box',
  templateUrl: './error-messages-box.component.html',
  styleUrls: ['./error-messages-box.component.scss'],
  imports: [],
})
export class ErrorMessagesBoxComponent {
  @Input() errorMessage: string;
}
